module.exports = __webpack_public_path__ + "img/ADYG.742368a5.png";